import { SERVICES, BUSINESS } from "@/lib/business";
import ServiceCard from "@/components/site/ServiceCard";
import RatingPill from "@/components/site/RatingPill";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Calendar, Phone } from "lucide-react";

export default function Services() {
  return (
    <div>
      <section className="hero-wash" data-testid="services-hero">
        <div className="container-x py-12 sm:py-16">
          <p className="text-sm font-semibold text-[color:var(--icrack-magenta-deep)] uppercase tracking-wider">Repair Services</p>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold">Everything we fix — phones, tablets, laptops &amp; Macs</h1>
          <p className="mt-3 max-w-2xl text-slate-600">From cracked iPhone screens to complex MacBook logic-board diagnostics, our Eastleigh workshop handles the full stack of modern device repairs — in-store or on a mobile call-out.</p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link to="/book"><Button className="h-11 rounded-xl btn-primary-magenta"><Calendar className="h-4 w-4 mr-2"/>Book Repair</Button></Link>
            <a href={`tel:${BUSINESS.phones[0].tel}`}><Button variant="outline" className="h-11 rounded-xl border-slate-200"><Phone className="h-4 w-4 mr-2" style={{color:"var(--icrack-magenta)"}}/>Call for a Quote</Button></a>
            <RatingPill />
          </div>
        </div>
      </section>

      <section className="section-pad" data-testid="services-catalog">
        <div className="container-x">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {SERVICES.map(s => <ServiceCard key={s.slug} service={s} />)}
          </div>
        </div>
      </section>

      <section className="section-pad bg-slate-50" data-testid="services-details">
        <div className="container-x space-y-6">
          <h2 className="font-display text-3xl font-bold">Service details</h2>
          <div className="grid gap-6 md:grid-cols-2">
            {SERVICES.map(s => (
              <div key={s.slug} className="flex gap-4 rounded-2xl border border-slate-200 bg-white p-4" data-testid={`services-detail-${s.slug}`}>
                <img src={s.image} alt={s.title} loading="lazy" className="h-24 w-32 flex-shrink-0 rounded-xl object-cover border border-slate-100" />
                <div>
                  <h3 className="font-display text-lg font-semibold">{s.title}</h3>
                  <p className="mt-1 text-sm text-slate-700 leading-relaxed">{s.short}</p>
                  <Link to="/book" className="mt-2 inline-block link-magenta text-sm font-semibold">Book this repair →</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
